export default "__VITE_ASSET__CSa8NPvH__"